import { Deserializable } from '../deserializable';

export class AgentSecurityQuestion implements Deserializable {
  public AgentID: number;
  public SecurityQuestionCode: string;
  public Answer: string;
  public Id: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
